import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const pricingItems = [{
  title: "Basement Flood Extraction",
  description: "Rapid response for standing water in Pueblo West",
  price: "Urgent"
}, {
  title: "Burst Pipe Remediation",
  description: "Immediate structural drying and pipe repair",
  price: "24/7"
}, {
  title: "Storm Damage Cleanup",
  description: "Debris removal and water mitigation in Canon City",
  price: "Fast"
}, {
  title: "Sewage Backup Sanitization",
  description: "Professional biohazard cleaning and restoration",
  price: "Expert"
}, {
  title: "Structural Drying Service",
  description: "Industrial-grade dehumidification for Florence homes",
  price: "Pro"
}, {
  title: "Mold Prevention Treatment",
  description: "Post-flood antimicrobial application and sealing",
  price: "Secure"
}];
export default function PricingList() {
  return <section data-section-id="256794" id="pueblohomeownertestimonials" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        {/* Header Section */}
        <div className="text-center mb-12">
          <span className="text-primary font-semibold tracking-wider uppercase text-sm mb-3 block">
            Pueblo Emergency Response
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground font-default mb-4">
            What Pueblo Homeowners Say
          </h2>
          <p className="text-muted-foreground text-lg">
            When water damage strikes, every minute counts. Here is how we help our neighbors.
          </p>
        </div>

        {/* Testimonials/Services List */}
        <Card className="py-0 gap-0 overflow-hidden shadow-lg border-border/60 bg-card rounded-md">
          {pricingItems.map((item, i) => <div key={i} data-index={i} className="flex flex-col sm:flex-row sm:items-center justify-between p-6 border-b border-border/60 last:border-b-0 hover:bg-accent/10 transition-colors duration-200 gap-2 sm:gap-4">
              <div>
                <h3 className="font-semibold text-foreground font-default text-lg">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  {item.description}
                </p>
              </div>
              <div className="text-2xl font-bold text-primary font-default shrink-0">
                {item.price}
              </div>
            </div>)}
        </Card>

        {/* Call to Action */}
        <div className="mt-10 flex flex-col items-center text-center">
          <Button size="lg" className="h-14 px-8 text-base rounded-md shadow-xl bg-primary text-primary-foreground hover:bg-primary/90 transition-all">
            <SafeHydrate><Calendar className="mr-2 size-5" /></SafeHydrate>
            Request Immediate Restoration
          </Button>
          <p className="text-sm text-muted-foreground mt-4">
            Our team arrives quickly and starts the restoration process immediately.
          </p>
        </div>
      </div>
    </section>;
}